import { createPopper } from "@popperjs/core";

export default new (class Tooltip {
    constructor() {
        this.tooltips = [];

        this.init();

        window.addEventListener("resize", (e) => this.resizeAll());
    }

    init() {    
        document.querySelectorAll(".tooltip").forEach((tooltip) => {
            if (tooltip.classList.contains('_inited')) return;

            const popcorn = tooltip.parentElement.querySelector('.tooltip-btn');
            const tooltipContent = tooltip;
            let popperInstance = createPopper(popcorn, tooltipContent, {
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [8, 8]
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: 8,
                            // boundary: document.querySelector(".tooltips"),
                            altBoundary: true,
                            rootBoundary: 'document'
                        }
                    },
                    // {
                    //     name: 'flip',
                    //     options: {
                    //         fallbackPlacements: ['top', 'bottom'],
                    //         boundary: document.querySelector(".tooltips"),
                    //     },
                    // },
                ],
                placement: tooltip.classList.contains('tooltip_category') ? 'bottom' : "top",
            });
            this.tooltips.push(popperInstance);

            this.resize(popperInstance);
            tooltip.classList.add('_inited');

        });
    }

    resizeAll() {
        this.tooltips = this.tooltips.filter((popperInstance) => {
            if (document.contains(popperInstance.state.elements.popper)) {
                this.resize(popperInstance);
                return true
            }
        }); 
    }

    resize(popperInstance) {
        if (window.innerWidth > 993) {
            popperInstance.setOptions({
                placement: popperInstance.state.elements.popper.classList.contains('tooltip_category') ? 'bottom' : "top",
            });
        } else {
            popperInstance.setOptions({
                placement: popperInstance.state.elements.popper.classList.contains('tooltip_category') ? 'bottom' : "top",
            });
        }
    }
})();
